import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { decimalNumber } from '@app/shared/common';
import { reduce } from 'lodash';
import { IProgressBarItem } from './xux-progress-bar.component.type';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'xux-progress-bar',
  templateUrl: './xux-progress-bar.component.html',
  styleUrls: ['./xux-progress-bar.component.scss'],
})
export class XuxProgressBarComponent implements OnChanges {
  @Input() public data: IProgressBarItem[] = [];
  @Input() public suffixSetting: string = '';
  @Input() public NoDataText: string = '';
  @Input() public baseOffsetX: number = 15;
  @Output() public hoverEvent = new EventEmitter<IProgressBarItem>();

  public hoveredIndex: number = -1;
  public tooltipX: number = 0;
  public tooltipY: number = 0;
  public NoDataColor: string = '#EEE';
  public totalValue: number = 0;
  public isEmptyData: boolean = true;
  @ViewChild('barContainer', { static: false })
  public barContainerElement: ElementRef;

  public ngOnChanges(changes) {
    if (changes.data) {
      this.totalValue = reduce(
        this.data,
        (sum, item) => decimalNumber(sum).add(item.value).valueOf(),
        0,
      );
      this.isEmptyData = this.totalValue === 0;
    }

    if (changes.suffixSetting) {
      this.suffixSetting = changes.suffixSetting.currentValue;
    }
  }

  public onHover(i: number, event: MouseEvent) {
    const baseOffsetY = 20; // use it to adjust tooltip top position because the progressbar wrapper height is too large
    const rect = this.barContainerElement.nativeElement.getBoundingClientRect();
    this.hoveredIndex = i;
    this.tooltipX = event.clientX - rect.left + this.baseOffsetX;
    this.tooltipY = Math.max(
      Math.min(event.clientY - rect.top, rect.height) - baseOffsetY,
      0,
    );

    if (!this.isEmptyData) {
      this.hoverEvent.emit({
        ...this.data[this.hoveredIndex],
      });
    } else {
      this.hoverEvent.emit(null);
    }
  }

  public onLeave() {
    this.hoveredIndex = -1;

    this.hoverEvent.emit(null);
  }

  public calcBarWidth(data: IProgressBarItem): number {
    const curValue = data.value || 0;
    const totalValue = this.totalValue || 1;
    if (isNaN(curValue) || isNaN(totalValue) || totalValue === 0) {
      return 0;
    }

    return Math.round(
      // eslint-disable-next-line newline-per-chained-call
      decimalNumber(curValue).div(decimalNumber(totalValue)).mul(100).valueOf(),
    );
  }
}
